export default __webpack_public_path__ + "static/media/shoes.78b4c8c5.jfif";